// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

// Atoms
import Spacer from 'atoms/Spacer'
import FieldLayout from '../FieldLayout'

export default class LiveChatRequireUserInfoEditor extends Component {
  static propTypes = {
    onDelete: PropTypes.func.isRequired,
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete()
  }

  render() {
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Require user info" onDelete={this.handleDelete} />
      </Fragment>
    )
  }
}
